import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Document } from 'src/app/shared/document';

/**
 * @description
 * Presentation-only component that displays the delivery-conditions receipt section of
 * a document. Renders the four configurable label + value pairs for general delivery
 * conditions, delivery terms, seller's note, and buyer's note.
 *
 * The component has no subscriptions, no outputs, and no mutable state beyond its
 * `@Input()` fields. It only reacts to `document` changes via `ngOnChanges`.
 *
 * ### Inputs
 * | Input           | Type     | Description                                     |
 * |-----------------|----------|-------------------------------------------------|
 * | `document`      | Document | The document whose condition fields are shown   |
 * | `docDelvConds`  | string   | Label for general delivery conditions field     |
 * | `docDelvTerms`  | string   | Label for delivery terms field                  |
 * | `docNoteText1`  | string   | Label for seller's note field                   |
 * | `docNoteText2`  | string   | Label for buyer's note field                    |
 */
@Component({
  selector: 'app-edit-document-conditions-receipt',
  templateUrl: './edit-document-conditions-receipt.component.html',
  styleUrls: ['./edit-document-conditions-receipt.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditDocumentConditionsReceiptComponent implements OnInit, OnChanges {

  @Input() document: Document;

  @Input() docDelvConds: string = 'Общие условия поставки';
  @Input() docDelvTerms: string = 'Срок выполнения (поставки)';
  @Input() docNoteText1: string = 'Примечание для продавца';
  @Input() docNoteText2: string = 'Примечание для покупателя';

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** EditDocumentConditionsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** EditDocumentConditionsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** EditDocumentConditionsComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'document':
          if (change.currentValue) {
          }
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** EditDocumentConditionsComponent in ngOnInit');
  }

}

